import { GatsbyImage } from 'gatsby-plugin-image';
import get from 'lodash.get';
import PropTypes from 'prop-types';
import React from 'react';

import { ReactComponent as Arrow } from '../../images/icons/fs-lc-arrow.svg';
import SmartLink from './SmartLink';
import * as styles from './SquareCards.module.css';

const SquareCards = ({ cards }) => {
  if (!cards) return null;
  return (
    <div className={styles.cards}>
      {cards.map((card, i) => {
        let url = card.url;
        if (url && url.indexOf('http') !== 0 && url[0] !== '/') {
          url = `/${url}`;
        }
        const isSvg = get(card, 'image.file.contentType') === 'image/svg+xml';
        const labelColor = card.buttonColor || 'black';
        const content = (
          <>
            {isSvg && <img loading="lazy" src={get(card, 'image.file.url')} alt={get(card, 'image.title')} />}
            {!isSvg && (
              <GatsbyImage image={get(card, 'image.gatsbyImageData')} loading="lazy" alt={get(card, 'image.title')} />
            )}
            {card.ctaLabel && url && (
              <span className={styles[labelColor]}>
                {card.ctaLabel}
                <Arrow className={styles.arrow} />
              </span>
            )}
          </>
        );

        return (
          <div className={styles.customerImage} key={i}>
            {url && <SmartLink to={url}>{content}</SmartLink>}
            {!url && <>{content}</>}
          </div>
        );
      })}
    </div>
  );
};

SquareCards.propTypes = {
  cards: PropTypes.array.isRequired,
};

export default SquareCards;
